import { FiChevronRight } from "react-icons/fi";
import { Avatar } from "~/components/Avatar";
import { Text } from "~/components/Text";

type Manager = {
  id: string;
  primary: boolean;
  displayHost: boolean;
  profileName?: string | null;
  profileHeadline?: string | null;
  profileDescription?: string | null;
  profileImageUrl?: string | null;
  user: {
    id: string;
    firstName: string;
    profileImageUrl: string;
  };
};

type HostsCardsProps = {
  managers: Manager[];
  clubLocation?: string | null;
  onSelect: () => void;
};

export function HostsCards({
  managers,
  clubLocation,
  onSelect,
}: HostsCardsProps) {
  const visible = managers.filter((m) => m.displayHost);
  if (visible.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      {visible.map((manager) => {
        const name = manager.profileName ?? manager.user.firstName;
        const image = manager.profileImageUrl ?? manager.user.profileImageUrl;
        const subtitle = [manager.profileHeadline, clubLocation]
          .filter(Boolean)
          .join(" · ");
        return (
          <div key={manager.id} className="flex flex-col gap-2">
            <button
              type="button"
              onClick={onSelect}
              className="group flex items-center gap-3 text-left"
            >
              <Avatar
                user={{
                  firstName: name,
                  name,
                  profileImageUrl: image ?? undefined,
                }}
                size={56}
                className="flex-shrink-0"
              />
              <div className="min-w-0 flex-1">
                <Text
                  variant="secondary"
                  size="md"
                  weight="bold"
                  className="truncate"
                >
                  {name}
                </Text>
                {subtitle && (
                  <Text variant="secondary" size="xs" className="line-clamp-1">
                    {subtitle}
                  </Text>
                )}
              </div>
              <FiChevronRight
                size={16}
                className="flex-shrink-0 text-butter-green transition-transform group-hover:translate-x-0.5"
                aria-hidden
              />
            </button>
            {manager.profileDescription && (
              <Text
                variant="secondary"
                size="md"
                className="whitespace-pre-line leading-relaxed"
              >
                {manager.profileDescription.trim()}
              </Text>
            )}
          </div>
        );
      })}
    </div>
  );
}
